"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStorage = exports.removeStorage = exports.saveStorage = void 0;
function saveStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}
exports.saveStorage = saveStorage;
function removeStorage(key) {
    localStorage.removeItem(key);
}
exports.removeStorage = removeStorage;
function getStorage(key) {
    if (localStorage.getItem(key)) {
        return JSON.parse(localStorage.getItem(key));
    }
    return;
}
exports.getStorage = getStorage;
//# sourceMappingURL=storage.js.map